import { useState } from "react";
import classes from "./DateField.module.css";

const DateField = (props) => {
  const {
    onFocus,
    onBlur,
    className,
    label,
    onChange,
    type,
    value,
    disabled,
    placeholder,
  } = props;

  const [focused, setFocused] = useState(false);

  const handleFocus = () => {
    onFocus();
    setFocused(true);
  };

  const handleBlur = () => {
    onBlur();
    setFocused(false);
  };

  return (
    <div className={classes.container}>
      {(focused || value) && (
        <label className={`${disabled && classes.disabled}  ${classes.label}`}>
          {label}
        </label>
      )}
      <input
        onFocus={handleFocus}
        onBlur={handleBlur}
        className={className + " " + classes.dateField}
        disabled={disabled}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default DateField;
